import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/manage-user/customers';

const find = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}`, { branchId });
};

const findByUserId = (merchantId, userId) => {
	return Client.get(`${baseUrl}/${merchantId}/${userId}`);
};

const create = (payload) => {
	return Client.post(`${baseUrl}`, payload);
};

const update = (userId, payload) => {
	return Client.put(`${baseUrl}/${userId}`, payload);
};

const remove = (userId) => {
	return Client.del(`${baseUrl}/${userId}`);
};

export default {
	find,
	create,
	update,
	remove,
	findByUserId,
};
